import { useQuery } from '@apollo/client';

import { getBadgePageUrl } from 'bundles/accomplishments/utils/routingUtils';
import IssuedBadgesQuery from 'bundles/enterprise-learning-path-description-page/module-renderer/data/IssuedBadges.graphql';
import type {
  BadgeTemplateQuery,
  BadgeTemplateQueryVariables,
} from 'bundles/enterprise-learning-path-description-page/module-renderer/data/__generated__/IssuedBadges';
import courseraOpenBadgesExperiments from 'bundles/epic/clients/courseraOpenBadges';

const useGetBadgeUrl = (badgeTemplateId: string, defaultPreviewUrl: string, isBadgeissued: boolean) => {
  const isCourseraBadgeEnabled = !!courseraOpenBadgesExperiments.get('courseraBadgeEnabled');

  const { data: issuedBadges } = useQuery<BadgeTemplateQuery, BadgeTemplateQueryVariables>(IssuedBadgesQuery, {
    context: { clientName: 'gatewayGql' },
    skip: !isBadgeissued || !isCourseraBadgeEnabled,
  });

  const issuedBadge = issuedBadges?.LearnerProfile?.me?.badges?.badges?.find(
    (badge) => badge.badgeTemplate.badgeTemplateId === badgeTemplateId
  );

  if (isCourseraBadgeEnabled && issuedBadge?.issuedBadgeSource === 'COURSERA') {
    // Coursera badge
    return getBadgePageUrl(issuedBadge.issuedBadgeId);
  } else if (issuedBadge?.issuedBadgeSource === 'CREDLY') {
    return `https://www.credly.com/badges/${issuedBadge.issuedBadgeId}`;
  }
  return defaultPreviewUrl;
};

export { useGetBadgeUrl };
